<template>
    <div style="box-shadow: none; background-color: #fff; border-radius: 8px; border: 1px solid #ddd; min-height: 480px;">
        <v-container fluid @mouseenter="hover = true" @mouseleave="hover = false"> 
            <v-row>
                <div class="d-flex align-center justify-space-between pa-2"  style="width: 100%; height: 56px;">
                    <div><h3 style="font-weight: 500;">{{st(config.title)}}
                        <v-tooltip bottom v-if="hover && config.description">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="grey lighten-1" style="cursor:pointer;" class="pl-1 pointer" dense v-bind="attrs" v-on="on">info</v-icon>
                            </template>
                            <span>{{st(config.description)}}</span>
                            </v-tooltip>
                        </h3></div>
                    <div v-if="!editMode && moduleLink" align="right" style="padding: 6px; margin-right:10px;">
                        <a :href="moduleLink.href">{{st(moduleLink.title)}}</a>
                    </div>
                    <div v-if="editMode" align="right" style="padding: 6px">
                        <v-btn :disabled="!enableLeft" icon color="primary" @click="$emit('edit-action', -1)" ><v-icon>arrow_back</v-icon></v-btn>
                        <v-btn :disabled="!enableRight" icon color="primary" @click="$emit('edit-action', 1)"><v-icon>arrow_forward</v-icon></v-btn>
                        <v-btn icon color="primary" @click="$emit('edit-action', 0)"><v-icon>delete_outline</v-icon></v-btn>
                    </div>
                </div>
            </v-row>
            <!--<v-row>
                <v-col cols="9"><h3>{{st(config.title)}}</h3></v-col>
                <v-col  v-if="editMode" cols="3" align="right" style="padding: 6px">
                    <v-btn :disabled="!enableLeft" icon color="primary" @click="$emit('edit-action', -1)" ><v-icon>arrow_back</v-icon></v-btn>
                    <v-btn :disabled="!enableRight" icon color="primary" @click="$emit('edit-action', 1)"><v-icon>arrow_forward</v-icon></v-btn>
                    <v-btn icon color="primary" @click="$emit('edit-action', 0)"><v-icon>delete_outline</v-icon></v-btn>
                </v-col>
            </v-row>-->
            <v-row>
                <TableWidget ref="tableWidget" v-if="(config.type==0)" :config="config" :context="context"/>
                <BarchartWidget ref="barchartWidget" v-if="(config.type==1)" :config="config" :context="context"/>
                <LinechartWidget ref="linechartWidget" v-if="(config.type==2)" :config="config" :context="context"/>
                <PiechartWidget ref="piechartWidget" v-if="(config.type==3)" :config="config" :context="context"/>
                <IframeWidget ref="iframeWidget" v-if="(config.type==4)" :config="config" :context="context"/>
                <MapsWidget ref="mapsWidget" v-if="(config.type==5)" :config="config" :context="context"/>
                <QBWidget ref="qbWidget" v-if="(config.type==100)" :config="config" :context="context"/>
            </v-row>
        </v-container>
    </div>
</template>
 
 <script> 
 import BaseModule from '../../common/BaseModule.js'
 import TableWidget from './TableWidget'
 import BarchartWidget from './charts/BarchartWidget'
 import PiechartWidget from './charts/PiechartWidget'
 import LinechartWidget from './charts/LinechartWidget'
 import IframeWidget from './IframeWidget'
 import QBWidget from './QBWidget'
 import MapsWidget from './MapsWidget'

 export default {
   name: 'WidgetWrapper',
   props: ['config','context','editMode','enableLeft','enableRight'],
   mixins: [BaseModule],
   components: { 
    TableWidget, BarchartWidget, LinechartWidget, PiechartWidget,IframeWidget,MapsWidget, QBWidget
   },
   
   data() {
       return {
        hover:false,
        moduleLink: {},
       }
   },
    mounted() {
        this.widgetConfig = this.config.fields ? JSON.parse(this.config.fields): {};
        this.moduleLink = this.widgetConfig.moduleLink?this.widgetConfig.moduleLink:{};
    },watch: {
       context: function() { 
        
      }
     },
    methods: {
        update() {
            for (const [key] of Object.entries(this.$refs)) {
                if (this.$refs[key].update) {
                    this.$refs[key].update();
                }
            }
        }
    }
 };
 </script>
  